import $ from 'jquery';
import 'slick-carousel';
import fitty from 'fitty';

// window.$ = $;

// window.prev = function() {$('.slideshow--left .slider').slick('slickPrev');}
// window.next = function() {$('.slideshow--left .slider').slick('slickNext');}

export default function home() {
	
	fitty('.slideshow__text--heading .item > div', {maxSize:260});
	splitSlider();
	servicesSlider();
	
}

function splitSlider() {
	var $slider = $('.slideshow--left');
	var	maxItems = $('.item', $slider).length;
	var	dragging = false;
	var	tracking;
	var	rightTracking;
	var	newTracking;

	var $sliderRight = $('.slideshow--right .slider');
	var $sliderHeading = $('.slideshow__text--heading');
	var $sliderSubheading = $('.slideshow__text--subheading');

	$('.slideshow--left .slider').slick({
		vertical: true,
		verticalSwiping: true,
		arrows: false,
		infinite: true,
		dots: false,
		speed: 1000,
		cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
		autoplay: true,
		autoplaySpeed: 5000,
		lazyLoad: 'progressive',
	})
	.on('beforeChange', function(event, slick, currentSlide, nextSlide) {

		if (currentSlide > nextSlide && nextSlide == 0 && currentSlide == maxItems - 1) {
			var sliderRightGoTo = -1;
			var sliderHeadingsGoTo = maxItems;
		} else if (currentSlide < nextSlide && currentSlide == 0 && nextSlide == maxItems - 1) {
			var sliderRightGoTo = maxItems;
			var sliderHeadingsGoTo = -1;
		} else {
			var sliderRightGoTo = maxItems - 1 - nextSlide;
			var sliderHeadingsGoTo = nextSlide;
		}

		$sliderRight.slick('slickGoTo', sliderRightGoTo);
		$sliderHeading.slick('slickGoTo', sliderHeadingsGoTo);
		$sliderSubheading.slick('slickGoTo', sliderHeadingsGoTo);
	})
	.on('mousewheel', function(event) {
		if (event.deltaX > 0 || event.deltaY < 0) {
			$(this).slick('slickNext');
		} else if (event.deltaX < 0 || event.deltaY > 0) {
			$(this).slick('slickPrev');
		};
	})
	.on('mousedown touchstart', function(){
		dragging = true;
		tracking = $('.slick-track', $slider).css('transform');
		tracking = parseInt(tracking.split(',')[5]);
		rightTracking = $('.slideshow--right .slick-track').css('transform');
		rightTracking = parseInt(rightTracking.split(',')[5]);
	})
	.on('mousemove touchmove', ()=>{
		if (dragging) {
			newTracking = $('.slideshow--left .slick-track').css('transform');
			newTracking = parseInt(newTracking.split(',')[5]);
			var diffTracking = newTracking - tracking;
			$('.slideshow--right .slick-track').css({'transform': 'matrix(1, 0, 0, 1, 0, ' + (rightTracking - diffTracking) + ')'});
		}
	})
	.on('mouseleave touchend mouseup', ()=>{
		dragging = false;
	});


	$sliderRight.slick({
		swipe: false,
		dots:false,
		vertical: true,
		arrows: false,
		infinite: true,
		speed: 950,
		cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
		initialSlide: maxItems - 1,
		lazyLoad: 'ondemand',
	});


	$('.slideshow__text--heading').slick({
		swipe: false,
		vertical: true,
		arrows: false,
		infinite: true,
		speed: 900,
		cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)'
	});

	$('.slideshow__text--subheading').slick({
		swipe: false,
		vertical: false,
		fade:true,
		arrows: false,
		infinite: true,
		speed: 1200,
		cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)'
	});

}


function servicesSlider() {

	var sliderOptions = (()=>{
		let el = document.querySelector('.services-slider');
		let optionsStr = el.getAttribute('data-slider-options');
		if (!el || !optionsStr) return false;

		let parsedJson = JSON.parse(optionsStr);
		return parsedJson;
	})();
	


	$('.services-slider__slider').slick({
		slidesToShow: 4,
		slidesToScroll: 4,
		dots: true,
		arrows: false,
		fade: sliderOptions['slider_type'] === 'fade',
		autoplay: true,
		autoplaySpeed: parseInt(sliderOptions['autoplay_duration'], 10) * 1000,
		responsive: [
			{
				breakpoint: 840,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3
				}
			},
			{
				breakpoint: 500,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				}
			},
			{
				breakpoint: 400,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			},

		]
	});

	// Previous | Next Buttons
	[...document.querySelectorAll('.services-slider__arrow')].forEach(function(button) {
		button.addEventListener('click', function() {
			$('.services-slider__slider').slick(`slick${button.getAttribute('data-direction')}`);
		})
	});
}






